import { useMemo } from 'react';
import { useOrchestratorList } from '../../hooks/useOrchestratorList';
import { formatLocalDate, formatDuration } from '../../utils/dates';
import { BaseChartTable } from '../shared/BaseChartTable';
import { useNidNavigation } from '../../hooks/useNidNavigation';
import { renderCommonCells } from '../shared/chartTableHelpers';

interface RejectedChartTableProps {
  selectedReasonKey?: string | null;
  onResetSelection: () => void;
}

export const RejectedChartTable = ({
  selectedReasonKey,
  onResetSelection,
}: RejectedChartTableProps) => {
  const { orchestrators } = useOrchestratorList();
  const { handleNidClick } = useNidNavigation();

  const tableData = useMemo(() => {
    const data: Array<{
      nid: string;
      processName: string;
      reasonForDiscard: string;
      rejectedDate: string;
      totalDuration: string;
      reasonKey: string;
    }> = [];

    orchestrators.data?.forEach(o => {
      o.workflow_steps.forEach(ws => {
        ws.responses.forEach(r => {
          if (r.status === 'REJECTED' && r.reason_for_discard) {
            let aux = '';

            switch (ws.name) {
              case 'idm revision de documentos':
                aux = 'docs';
                break;
              case 'idm pricing manual':
                aux = 'pricing';
                break;
              default:
                aux = ws.name;
                break;
            }

            const reasonKey = `${aux}: ${r.reason_for_discard.label}`;

            if (!selectedReasonKey || reasonKey === selectedReasonKey) {
              data.push({
                nid: o.nid,
                processName: ws.name,
                reasonForDiscard: r.reason_for_discard.label,
                rejectedDate: formatLocalDate(r.created_at),
                totalDuration: formatDuration(o.start_at, r.created_at),
                reasonKey,
              });
            }
          }
        });
      });
    });

    return data;
  }, [orchestrators.data, selectedReasonKey]);

  const exportData = useMemo(
    () =>
      tableData.map((item, index) => ({
        'No.': index + 1,
        NID: item.nid,
        'Nombre del Proceso': item.processName,
        'Razón de Rechazo': item.reasonForDiscard,
        'Fecha de Rechazo': item.rejectedDate,
        'Tiempo Total': item.totalDuration,
      })),
    [tableData]
  );

  return (
    <BaseChartTable
      title="Datos de Rechazados"
      data={tableData}
      headers={[
        'No.',
        'NID',
        'Nombre del Proceso',
        'Razón de Rechazo',
        'Fecha de Rechazo',
        'Tiempo Total',
      ]}
      renderRow={(row, index) => (
        <tr key={index}>
          {renderCommonCells(row, index, handleNidClick)}
          <td>{row.reasonForDiscard}</td>
          <td>{row.rejectedDate}</td>
          <td>{row.totalDuration}</td>
        </tr>
      )}
      exportData={exportData}
      exportFilename={`rechazados_${new Date().toISOString().split('T')[0]}`}
      hasSelection={!!selectedReasonKey}
      onResetSelection={onResetSelection}
    />
  );
};
